// Maps a tube-colour name (as returned by the backend, usually Russian) to a
// concrete CSS colour used for the label's coloured stripe.
const TUBE_COLOR_MAP: { match: string[]; color: string }[] = [
  { match: ['фиолет', 'purple', 'violet', 'эдта'], color: '#9333ea' },
  { match: ['красн', 'red'], color: '#dc2626' },
  { match: ['голуб', 'син', 'blue', 'light blue'], color: '#2563eb' },
  { match: ['зел', 'green'], color: '#16a34a' },
  { match: ['сер', 'gray', 'grey'], color: '#6b7280' },
  { match: ['жёлт', 'желт', 'yellow'], color: '#eab308' },
  { match: ['чёрн', 'черн', 'black'], color: '#111827' },
  { match: ['оранж', 'orange'], color: '#ea580c' },
]

export function resolveTubeColor(tubeColorName?: string | null): string {
  if (!tubeColorName) return '#9333ea'
  const normalized = tubeColorName.toLowerCase()
  const found = TUBE_COLOR_MAP.find((entry) =>
    entry.match.some((token) => normalized.includes(token)),
  )
  return found?.color ?? '#9333ea'
}

// "18.12.2024 19:00" — compact form used on the printed label.
export function formatLabelDateTime(value?: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`
}

// "18 дек 2024, 19:00" — readable form used in the configuration panel.
export function formatConfigDateTime(
  value: string | null | undefined,
  locale: string,
): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const localeTag =
    locale === 'uz' ? 'uz-UZ' : locale === 'uz-Cyrl' ? 'uz-Cyrl' : 'ru-RU'
  return date.toLocaleString(localeTag, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatBirthDate(value?: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString('ru-RU')
}

// Order number shown as "<card>-<tube №>", e.g. "99420-ВК-001".
export function formatOrderNumber(
  cardNumber: string | null | undefined,
  tubeNumber: number | null | undefined,
): string {
  const card = cardNumber || '—'
  if (tubeNumber == null) return card
  return `${card}-${String(tubeNumber).padStart(3, '0')}`
}
